<template>
  <div>
    <invoices-add></invoices-add>
  </div>
</template>

<script>
import InvoicesAdd from 'components/Invoices/Add'

export default {
  components: {
    InvoicesAdd
  }
}
</script>

<style lang="scss" scoped>
</style>



/** WEBPACK FOOTER **
 ** Add.vue?354119b0
 **/